// extracted by mini-css-extract-plugin
export default {"contactFormContainer":"ContactForm_contactFormContainer__t77CC","form":"ContactForm_form__syTnw"};